import {ensureHttpsUrl} from '@/utils';
import {useState, useEffect} from 'react';

export const useMixedContent = (thumbnailUrl) => {
  const [imgSrc, setImgSrc] = useState('');
  const [loading, setLoading] = useState(true);
  const [securedImageError, setSecuredImageError] = useState(false);

  useEffect(() => {
    if (!thumbnailUrl) {
      setLoading(false);
      return;
    }

    // thumbnailUrl가 http:// 혹은 //로 시작되는경우 https://로 치환
    const securedUrl = ensureHttpsUrl(thumbnailUrl);

    const img = new Image();

    img.onload = () => {
      setImgSrc(securedUrl);
      setLoading(false);
    };

    img.onerror = () => {
      setSecuredImageError(true);
      setLoading(false);
    };

    img.src = securedUrl;
  }, [thumbnailUrl]);

  return {imgSrc, loading, securedImageError};
};
